import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index';

import Dashboard from '../pages/Dashboard';
import ConsultancyProfile from '../pages/ConsultancyProfile';
import Login from '../pages/Login';
import Signup from '../pages/Signup';
import TrackVisa from '../pages/TrackVisa';
import Profile from '../pages/Profile';
import VisaDetail from '../pages/VisaDetail';

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: Dashboard,
      meta:{
        title: 'Consultancy Finder'
      }
    },
    {
      path: '/profile/:consultancy_id',
      component: ConsultancyProfile,
      async beforeEnter(to, from ,next) {
      await store.dispatch('getConsultancy', to.params.consultancy_id);
      next();
      },
      meta:{
        title: 'Consultancy Profile - Consultancy Finder'
      }
    },
    {
      path: '/login',
      component: Login,
      meta:{
        title: 'Login - Consultancy Finder'
      }
    },
    {
      path: '/signup',
      component: Signup,
      meta:{
        title: 'Sign Up - Consultancy Finder'
      }
    },
    {
      path: '/trackvisa',
      component: TrackVisa,
      meta:{
        title: 'Track Visa - Consultancy Finder'
      }
    },
    {
      name:'addEditStudent',
      path: '/student',
      component: Profile,
      meta: {
        auth: true,
        title: 'Student Profile - Consultancy Finder'
      }
    },
    {
      path: '/visadetail',
      component: VisaDetail,
      meta:{
        title: 'Visa Detail - Consultancy Finder'
      }
    },
  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js